export const start = () => (dispatch) => {
  dispatch({
    type: "START",
  });
};

export const setName =
  ({ first_name, last_name, email_address, job_applying }) =>
  (dispatch) => {
    dispatch({
      type: "SET_NAME",
      first_name,
      last_name,
      email_address,
      job_applying,
    });
  };

export const changeView = (view) => (dispatch) => {
  dispatch({
    type: "CHANGE_VIEW",
    view,
  });
};

export const nextQuestion = (question_id, choice_ids) => (dispatch) => {
  dispatch({
    type: "NEXT_QUESTION",
    question_id,
    choice_ids,
  });
};

export const previousQuestion = () => (dispatch) => {
  dispatch({
    type: "PREVIOUS_QUESTION",
  });
};

export const setScales = (scales) => (dispatch) => {
  dispatch({
    type: "SET_SCALES",
    scales,
  });
};

export const setDemographics = (demographics) => (dispatch) => {
  dispatch({
    type: "SET_DEMOGRAPHICS",
    demographics,
  });
};

export const setSportDemographics =
  (sport, position, level, gender) => (dispatch) => {
    dispatch({
      type: "SET_SPORT_DEMOGRAPHICS",
      sport,
      position,
      level,
      gender,
    });
  };

export const setTimeExpired = (is_time_expired) => (dispatch) => {
  dispatch({
    type: "SET_TIME_EXPIRED",
    is_time_expired,
  });
};

export const initializeTest =
  (
    exam_id,
    tester_id,
    demographic_fields,
    sport_demographic_fields,
    sessions,
    exams,
    total_question,
    approximate_time,
    last_session_info,
    redirect_url,
    dist_url,
    candidate_consent,
    platform_logo,
    client_platform_logo,
    browser_info,
    has_security_features,
    has_job_application,
    enabled_open_question,
    open_questions,
    allow_screen_reader
  ) =>
  (dispatch) => {
    dispatch({
      type: "INITIALIZE_TEST",
      exam_id,
      tester_id,
      demographic_fields,
      sport_demographic_fields,
      sessions,
      exams,
      total_question,
      approximate_time,
      last_session_info,
      redirect_url,
      dist_url,
      candidate_consent,
      platform_logo,
      client_platform_logo,
      browser_info,
      has_security_features,
      has_job_application,
      enabled_open_question,
      open_questions,
      allow_screen_reader,
    });
  };

export const setTimeStatus =
  (stop_clock = true) =>
  (dispatch) => {
    dispatch({
      type: "INITIALIZE_TEST",
      stop_clock,
    });
  };

export const setKeyAndCode = (key, code) => (dispatch) => {
  dispatch({
    type: "SET_KEY_AND_CODE",
    key,
    code,
  });
};

export const setTesterId = (tester_id) => (dispatch) => {
  dispatch({
    type: "SET_TESTER_ID",
    tester_id,
  });
};

export const nextExam = () => (dispatch) => {
  dispatch({
    type: "NEXT_EXAM",
  });
};

export const setRemainingTime = () => (dispatch) => {
  dispatch({
    type: "SET_REMAINING_TIME",
  });
};

export const setExamStatus = (status) => (dispatch) => {
  dispatch({
    type: "SET_EXAM_STATUS",
    status,
  });
};

export const setExaminationCompleted = () => (dispatch) => {
  dispatch({
    type: "SET_EXAMINATION_COMPLETED",
  });
};

export const showModal =
  (modal_text, show_modal_close_button = true, modal_type = "WARNING") =>
  (dispatch) => {
    dispatch({
      type: "SHOW_MODAL",
      modal_text,
      show_modal_close_button,
      modal_type,
    });
  };

export const hideModal = () => (dispatch) => {
  dispatch({
    type: "HIDE_MODAL",
  });
};

export const setToErrorStatus = (errorstatus) => (dispatch) => {
  dispatch({
    type: "SET_TO_ERROR_STATUS",
    errorstatus,
  });
};

export const setStatus = (status) => (dispatch) => {
  dispatch({
    type: "SET_STATUS",
    status,
  });
};

export const setStartTime = (start_time) => (dispatch) => {
  dispatch({
    type: "SET_START_TIME",
    start_time: start_time,
  });
};

export const setlanguage = (lang) => (dispatch) => {
  dispatch({
    type: "SET_LANGUAGE",
    lang: lang,
  });
};

// testing for tranlation
export const setT = (t) => (dispatch) => {
  dispatch({
    type: "SET_T",
    t: t,
  });
};

export const setI18n = (i18n) => (dispatch) => {
  dispatch({
    type: "SET_I18N",
    i18n: i18n,
  });
};

export const setIdCaptureImage = (image) => (dispatch) => {
  dispatch({
    type: "SET_ID_CAPTURE_IMAGE",
    image,
  });
};

export const nextSection = (section) => (dispatch) => {
  dispatch({
    type: "NEXT_SECTION",
    section,
  });
};

export const setIsCertified = (is_certified) => (dispatch) => {
  dispatch({
    type: "SET_IS_CERTIFIED",
    is_certified,
  });
};

export const setIsPracticeDone = (is_practice_done) => (dispatch) => {
  dispatch({
    type: "SET_IS_PRACTICE_DONE",
    is_practice_done,
  });
};

export const setIsTypingStarted = (is_typing_started) => (dispatch) => {
  dispatch({
    type: "SET_IS_TYPING_STARTED",
    is_typing_started,
  });
};

export const startTyping = (test_name) => (dispatch) => {
  dispatch({
    type: "START_TYPING_TEST",
    test_name,
  });
};

export const setTypingTestDiff = (typing_test_diff) => (dispatch) => {
  dispatch({
    type: "SET_TYPING_TEST_DIFF",
    typing_test_diff,
  });
};

export const typingTestCompleted = () => (dispatch) => {
  dispatch({
    type: "TYPING_TEST_COMPLETED",
  });
};

export const nextDataEntryForm = (rotation_count) => (dispatch) => {
  dispatch({
    type: "NEXT_DATA_ENTRY_FORM",
    rotation_count,
  });
};

export const resetDataEntryForm = () => (dispatch) => {
  dispatch({
    type: "RESET_DATA_ENTRY_FORM",
  });
};

export const updateDataEntryData =
  (form_index, data_entry_form_data) => (dispatch) => {
    dispatch({
      type: "UPDATE_DATA_ENTRY_DATA",
      form_index,
      data_entry_form_data,
    });
  };

export const setDataEntryData =
  (dataEntryData, dataEntryCount) => (dispatch) => {
    dispatch({
      type: "SET_DATA_ENTRY_DATA",
      dataEntryData,
      dataEntryCount,
    });
  };

export const dataEntryTestCompleted = () => (dispatch) => {
  dispatch({
    type: "DATA_ENTRY_TEST_COMPLETED",
  });
};

export const setTempDataEntryData = (tempData) => (dispatch) => {
  dispatch({
    type: "SET_TEMP_DATA_ENTRY_DATA",
    tempData,
  });
};

export const resetTempDataEntryData = () => (dispatch) => {
  dispatch({
    type: "RESET_TEMP_DATA_ENTRY_DATA",
  });
};

export const nextOpenQuestion = (current_index, answer) => (dispatch) => {
  dispatch({
    type: "NEXT_OPEN_QUESTION",
    current_index,
    answer,
  });
};

export const previousOpenQuestion = (current_index) => (dispatch) => {
  dispatch({
    type: "PREVIOUS_OPEN_QUESTION",
    current_index,
  });
};

export const setOpenQuestionAnswerText = (text) => (dispatch) => {
  dispatch({
    type: "SET_OQ_ANSWER",
    text: text,
  });
};

export const setCheatCount = (count) => (dispatch) => {
  dispatch({
    type: "SET_CHEAT_COUNT",
    count: count,
  });
};

export const recordActivityCode = (code) => (dispatch) => {
  dispatch({
    type: "RECORD_ACTIVITY_CODE",
    code,
  });
};

export const setActivityTopCodes = (codes) => (dispatch) => {
  dispatch({
    type: "SET_ACTIVITY_TOP_CODES",
    codes,
  });
};

export const setActivityScores = (scores) => (dispatch) => {
  dispatch({
    type: "SET_ACTIVITY_SCORES",
    scores,
  });
};
